import SnowPlowAnalytics, { sp } from './SnowPlowAnalytics'

export { sp }
export default SnowPlowAnalytics
